import * as types from './solicitarBaixaMei.actionTypes';
import * as commonActionType from '@common/store/common/common.actionsType';
import store from '@common/store/store';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  tokenRecaptcha: '',
  recaptchaResetRef: undefined,
  SolicitarBaixaMeiModalToggle: false,
  GridSolicitarBaixaMeiPesquisa: [],
  SolicitarBaixaMeiDados: [],
  CpfCnpjSolicitante: undefined,
  CnpjEmpresa: undefined,
  CpfMei: undefined,
  SolicitarBaixaMeiHeader: undefined,
  SolicitarBaixaMeiEndereco: undefined,
  SolicitarBaixaMeiConteudo: undefined,
});

const reduce = (state = initialState, action = {}) => {
  const { payload } = action;
  switch (action.type) {
    case types.SET_TOKEN_RECAPTCHA:
      return state.merge({ tokenRecaptcha: payload });
    case types.TOGGLE_MODAL_SOLICITAR_BAIXA_MEI:
      return state.merge({ SolicitarBaixaMeiModalToggle: !state.SolicitarBaixaMeiModalToggle });
    case types.SET_SOLICITAR_BAIXA_MEI:
      return state.merge(payload);
    case types.SET_RECAPTCHA_RESET_REF:
      return state.merge({ recaptchaResetRef: payload });
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule('redeSIM.solicitarBaixaMei', reduce);
